import React, { useState, useEffect } from "react";
import { Link } from "react-scroll"; // ScrollLink for smooth scrolling
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../Assets/existencemedianobg.png";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");

  // Use IntersectionObserver to track which section is in view
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.7, 
    };

    const sections = document.querySelectorAll("section"); // Get all sections

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveTab(entry.target.id); // Set active tab based on the section's ID
        }
      });
    }, observerOptions);

    sections.forEach((section) => {
      observer.observe(section); // Start observing each section
    });

    return () => {
      // Clean up the observer on component unmount
      observer.disconnect();
    };
  }, []);

  // Handler for the "Services" link to ensure it becomes active when clicked
  const handleServiceClick = () => {
    setActiveTab("services");
  };

  // Handler for the "Portfolio" link to ensure it becomes active when clicked
  const handlePortfolioClick = () => {
    setActiveTab("portfolio");
  };

  // Close the menu when an item is clicked on mobile
  const closeMenu = () => {
    setToggle(false);
  };

  return (
    <Container>
      <Link to="/" className="link-styles">
        <img src={logo} alt="" className="logo" />
      </Link>
      <ul onClick={handleToggle} className={toggle ? "nav-menu active" : "nav-menu"}>
        <Link to="home" smooth={true} duration={500} offset={-70} onClick={closeMenu}>
          <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
            Home
          </li>
        </Link>

        <Link to="portfolio" smooth={true} duration={500} offset={-70} onClick={() => { handlePortfolioClick(); closeMenu(); }}>
          <li className={activeTab === "portfolio" ? "activeTab" : "nonActive"}>
            Portfolio
          </li>
        </Link>

        <Link to="services" smooth={true} duration={500} offset={-70} onClick={() => { handleServiceClick(); closeMenu(); }}>
          <li className={activeTab === "services" ? "activeTab" : "nonActive"}>
            Services
          </li>
        </Link>

        <Link to="about-us" smooth={true} duration={500} offset={-70} onClick={closeMenu}>
          <li className={activeTab === "about-us" ? "activeTab" : "nonActive"}>
            About Us
          </li>
        </Link>

        {/* Updated Contact Us Button */}
        <Link to="contact-us" smooth={true} duration={500} offset={-70} onClick={closeMenu}>
          <button>CONTACT US</button>
        </Link>
      </ul>
      <div className="mobile-menu" onClick={handleToggle}>
        {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
      </div>
    </Container>
  );
};

const Container = styled.div`
  background: #ffffff47;
  transition: 0.4s;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 4%;
  width: 100%;
  height: 70px;
  z-index: 100;
  box-sizing: border-box;
  color: #525252;
  top: 0;

  .logo {
    width: 60px;
    height: auto;
  }

  .nav-menu {
    display: flex;
    gap: 37px;
    list-style: none;
    align-items: center;
    li {
      color: #535353;
      font-weight: 400;
      transition: 0.3s;
      cursor: pointer;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }
    button {
      background: black;
      border: none;
      color: white;
      padding: 7px 14px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }
  }

  .mobile-menu {
    position: absolute;
    color: var(--fontPrimaryColor);
    right: 5%;
    font-size: 24px;
    cursor: pointer;
    transition: 0.3s;
    display: none;
    margin-top: 7px;
    :hover {
      transform: scale(1.1);
    }
  }

  @media (max-width: 600px) {
    .logo {
      width: 45px;
    }
    .nav-menu {
      width: 90%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 10%;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0%;
      right: -100%;
      transition: 0.3s;
      z-index: 99;
      background: white;
    }
    .mobile-menu {
      display: block;
      z-index: 99;
    }
    .nav-menu.active {
      right: 0%;
    }
  }
`;

export default Navbar;
